import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  CardText,
  Button,
  CardSubtitle,
  Table,
  ModalFooter,
  Badge,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import {
  FaPlus,
  FaEdit,
  FaEye,
  FaFileDownload,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { FiLoader } from "react-icons/fi";
import axios from "axios";
import uuid from "react-uuid";
import Moment from "moment";
import "../ExternalOrganisation/ExternalOrganisation.css";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import toast, { Toaster } from "react-hot-toast";

const ViewFarmSubscriptions = () => {
  const { id } = useParams();
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false);
  const [isRenewalChecked, setIsRenewalChecked] = useState();
  const [deleteItemId, setDeleteItemId] = useState(0);
  const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [tempSubscriptionList, setTempSubscriptionList] = useState([]);
  const [isRenewing, setIsRenewing] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [isTogglingAutoRenew, setIsTogglingAutoRenew] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showPaymentTypeModal, setShowPaymentTypeModal] = useState(false);
  const [infoModal, setInfoModal] = useState({
    open: false,
    title: "",
    message: "",
  });
  const [downloadingInvoiceKey, setDownloadingInvoiceKey] = useState(null);
  const openInfoModal = (title, message) =>
    setInfoModal({ open: true, title, message });
  const closeInfoModal = () => setInfoModal({ ...infoModal, open: false });
  const populateItemData = async () => {
    try {
      const response = await axios.get(
        "/api/Subscription/GetFarmSubscription/",
        {
          params: { farmId: id },
        }
      );
      setSubscriptionList(response.data);
      // setTempSubscriptionList(response.data);
      setLoading(false);
    } catch (err) {
      if (!err?.response) {
      } else if (err.response?.status === 400) {
      } else {
      }
    }
  };

  useEffect(() => {
    setIsRenewalChecked(subscriptionList.isAutoRenew);
  }, [subscriptionList]);

  const invoiceFileDownload = async (id, nameFileDoc) => {
    try {
      // Start request
      const response = await axios.get("/api/Subscription/DownloadInvoice", {
        params: {
          invoiceId: id,
          paymentType: subscriptionList?.paymentType || "Subscription",
        },
        responseType: "blob", // This tells axios to handle the response as a Blob
      });

      // Check if response is successful (axios uses status codes)
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // response.data is already a Blob when responseType is 'blob'
      const blob = response.data;
      const tempUrl = URL.createObjectURL(blob);

      const aTag = document.createElement("a");
      aTag.href = tempUrl;
      aTag.download = nameFileDoc;
      document.body.appendChild(aTag);

      aTag.click();

      // Clean up
      URL.revokeObjectURL(tempUrl);
      aTag.remove();

      // Show success popup
      //openInfoModal("Invoice", "Invoice downloaded successfully.");
    } catch (error) {
      console.error("Error downloading invoice:", error);
      const errorMessage =
        error?.response?.data?.errorMessage ||
        error?.message ||
        "Failed to download invoice. Please try again.";
      // toast.error(errorMessage, {
      //     duration: 4000,
      //     style: { border: '1px solid #dc3545', padding: '16px', color: 'black' }
      // });
      openInfoModal("Invoice Download Failed", errorMessage);
    }
  };

  const getInvoiceKey = (item) => {
    // Prefer transactionId as it is typically unique per row; fallback to invoiceId
    return String(item?.transactionId ?? item?.invoiceId ?? "");
  };

  const downloadInvoice = async (id, key) => {
    if (!id) return;
    try {
      setDownloadingInvoiceKey(key || String(id));
      await invoiceFileDownload(id, String(subscriptionList.farmName));
    } finally {
      setDownloadingInvoiceKey(null);
    }
  };

  const handleRenewNow = () => {
    if (!id) {
      toast.error("Farm ID is missing");
      return;
    }
    // Show payment type selection modal
    setShowPaymentTypeModal(true);
  };

  const processRenewal = async (isSubscription) => {
    setShowPaymentTypeModal(false);

    if (!id) {
      toast.error("Farm ID is missing");
      return;
    }

    setIsRenewing(true);
    let response;
    try {
      // Choose API endpoint based on user selection
      if (isSubscription) {
        response = await axios.post("/api/Subscription/RenewSubscription", {
          FarmId: parseInt(id),
        });
      } else {
        response = await axios.post("/api/Subscription/RenewOneTime", {
          FarmId: parseInt(id),
        });
      }

      if (response?.data?.status && response?.data?.content) {
        // Store context for success screen
        try {
          sessionStorage.setItem("renewFarmId", id);
          sessionStorage.setItem("isSubscription", isSubscription.toString());
          sessionStorage.setItem(
            "renewFarmName",
            subscriptionList?.farmName || ""
          );
        } catch {}

        openInfoModal("Payment", "Redirecting to payment...");
        setTimeout(() => {
          window.location.href = response.data.content;
        }, 500);
      } else {
        throw new Error(
          response?.data?.errorMessage || "Failed to initiate payment"
        );
      }
    } catch (error) {
      console.error("Error renewing subscription:", error);
      const errorMessage =
        error?.response?.data?.errorMessage ||
        error?.message ||
        "Failed to renew subscription. Please try again.";
      toast.error(errorMessage, {
        duration: 4000,
        style: { border: "1px solid #dc3545", padding: "16px", color: "black" },
      });
    } finally {
      setIsRenewing(false);
    }
  };

  const handleAutoRenewToggle = async (checked) => {
    const farmSubscriptionDetailId =
      subscriptionList?.cancelSubscriptionDetailId;

    if (!farmSubscriptionDetailId) {
      toast.error("Subscription detail ID is missing");
      return;
    }

    setIsTogglingAutoRenew(true);
    const previousState = isRenewalChecked; // Store previous state for rollback

    try {
      const response = checked
        ? await axios.post("/api/Subscription/RenewAutomatically", {
            FarmSubscriptionDetailId: parseInt(farmSubscriptionDetailId),
          })
        : await axios.post("/api/Subscription/TurnOffAutoRenew", {
            FarmSubscriptionDetailId: parseInt(farmSubscriptionDetailId),
          });

      if (response.data?.status) {
        const message = checked
          ? "Auto-renewal has been enabled successfully"
          : "Auto-renewal has been disabled successfully";

        openInfoModal("Auto-Renewal", message);

        // Refresh subscription data (this will update isRenewalChecked via useEffect)
        await populateItemData();
      } else {
        throw new Error(
          response.data?.errorMessage || "Failed to update auto-renewal setting"
        );
      }
    } catch (error) {
      console.error("Error toggling auto-renewal:", error);
      const errorMessage =
        error.response?.data?.errorMessage ||
        error.message ||
        "Failed to update auto-renewal. Please try again.";
      toast.error(errorMessage, {
        duration: 4000,
        style: { border: "1px solid #dc3545", padding: "16px", color: "black" },
      });
      // Revert checkbox state on error
      setIsRenewalChecked(previousState);
    } finally {
      setIsTogglingAutoRenew(false);
    }
  };

  const handleCancelSubscriptionClick = () => {
    setShowCancelModal(true);
  };

  const handleCancelSubscription = async () => {
    setShowCancelModal(false);

    // Get FarmSubscriptionDetailId from subscriptionList
    const farmSubscriptionDetailId =
      id || subscriptionList?.farmSubscriptionDetailId || subscriptionList?.id;
    if (!farmSubscriptionDetailId) {
      toast.error("Subscription detail ID is missing");
      return;
    }

    setIsCancelling(true);
    try {
      const response = await axios.post("/api/Subscription/TurnOffAutoRenew", {
        FarmSubscriptionDetailId: parseInt(
          subscriptionList?.cancelSubscriptionDetailId
        ),
      });

      if (response.data?.status) {
        openInfoModal(
          "Subscription",
          "Subscription has been cancelled successfully"
        );

        // Refresh subscription data
        await populateItemData();
      } else {
        // const errorMsg = response.data?.errorMessage || 'Failed to cancel auto-renewal';
        // toast.error(errorMsg, {
        //     duration: 4000,
        //     style: { border: '1px solid #dc3545', padding: '16px', color: 'black' }
        // });
      }
    } catch (error) {
      console.error("Error cancelling subscription:", error);
      const errorMessage =
        error.response?.data?.errorMessage ||
        error.message ||
        "Failed to cancel auto-renewal. Please try again.";
      toast.error(errorMessage, {
        duration: 4000,
        style: { border: "1px solid #dc3545", padding: "16px", color: "black" },
      });
    } finally {
      setIsCancelling(false);
    }
  };

  useEffect(() => {
    populateItemData();
  }, []);

  const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = React.useState(config);
    if (sortConfig == null) {
      setSortConfig({ key: "name", direction: "ascending" });
    }
    const sortedItems = React.useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (key) => {
      let direction = "ascending";
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }
      setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
  };
  const ProductTable = (props) => {
    const { renewHistory, ...product } = props?.products;

    return (
      <Table striped bordered hover style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Renew date</th>
            <th>Renew by</th>
            <th>Start date</th>
            <th>End Date</th>
            <th>Transaction id</th>
            <th>Amount</th>
            <th>Invoice</th>
          </tr>
        </thead>
        <tbody>
          {renewHistory == undefined && (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                Loading...
              </td>
            </tr>
          )}
          {renewHistory != undefined &&
            renewHistory != null &&
            renewHistory.map((item) => (
              <tr key={uuid()}>
                <td style={{ textAlign: "" }}>{item.renewDate}</td>
                <td style={{ textAlign: "" }}>{item.createdBy} </td>
                <td style={{ textAlign: "" }}>{item.startDate} </td>
                <td style={{ textAlign: "" }}>{item.endDate} </td>
                <td style={{ textAlign: "" }}>{item.transactionId} </td>
                <td style={{ textAlign: "" }}>${item.amount} </td>
                <td>
                  <button
                    style={{ backgroundColor: "#0d535d" }}
                    type="button"
                    disabled={
                      !item?.invoiceId ||
                      downloadingInvoiceKey === getInvoiceKey(item)
                    }
                    onClick={() =>
                      downloadInvoice(item.invoiceId, getInvoiceKey(item))
                    }
                    id="btnUpdate"
                    color="warning"
                    className="btn btn-sm btn-edit"
                  >
                    {downloadingInvoiceKey === getInvoiceKey(item) ? (
                      <FiLoader />
                    ) : (
                      <FaFileDownload />
                    )}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  };

  const handleChangeName = async (event) => {
    setName(event.target.value);
    if (event.target.value == "") {
      setSubscriptionList(tempSubscriptionList);
    } else {
      var list = [];
      list = tempSubscriptionList.filter(
        (x) =>
          (x.subscriptionId != null
            ? x.subscriptionId
                .toLowerCase()
                .includes(event.target.value.toLowerCase())
            : 0) ||
          (x.email != null
            ? x.email.toLowerCase().includes(event.target.value.toLowerCase())
            : 0) ||
          (x.farms != null
            ? x.farms.toLowerCase().includes(event.target.value.toLowerCase())
            : 0) ||
          (x.type != null
            ? x.type.toLowerCase().includes(event.target.value.toLowerCase())
            : 0)
      );
      setSubscriptionList(list);
    }
  };

  return (
    <div>
      <Toaster position="top-center" />
      <Modal isOpen={infoModal.open} toggle={closeInfoModal} centered>
        <ModalHeader toggle={closeInfoModal}>
          {infoModal.title || "Notice"}
        </ModalHeader>
        <ModalBody>{infoModal.message}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={closeInfoModal}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showCancelModal} toggle={() => setShowCancelModal(false)}>
        <ModalHeader toggle={() => setShowCancelModal(false)}>
          Cancel Auto-Renewal
        </ModalHeader>
        <ModalBody>
          Are you sure you want to cancel this subscription?
          You will need to manually renew your subscription when it expires.
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowCancelModal(false)}>
            No, Keep It
          </Button>{" "}
          <Button
            color="danger"
            onClick={handleCancelSubscription}
            disabled={isCancelling}
          >
            {isCancelling ? (
              <>
                <Spinner size="sm" className="me-2" />
                Cancelling...
              </>
            ) : (
              "Yes, Cancel"
            )}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showPaymentTypeModal}
        toggle={() => !isRenewing && setShowPaymentTypeModal(false)}
        centered
      >
        <ModalHeader
          toggle={() => !isRenewing && setShowPaymentTypeModal(false)}
        >
          Select Payment Type
        </ModalHeader>
        <ModalBody>
          <p className="mb-3">How would you like to renew your subscription?</p>
          {isRenewing && (
            <div className="text-center mb-3">
              <Spinner className="me-2" />
              <span>Processing your request...</span>
            </div>
          )}
          <div className="d-flex flex-column gap-3">
            <Card
              style={{
                cursor: isRenewing ? "not-allowed" : "pointer",
                border: "2px solid #e6e6e6",
                transition: "all 0.3s",
                opacity: isRenewing ? 0.6 : 1,
              }}
              onMouseEnter={(e) =>
                !isRenewing && (e.currentTarget.style.borderColor = "#0d535d")
              }
              onMouseLeave={(e) =>
                !isRenewing && (e.currentTarget.style.borderColor = "#e6e6e6")
              }
              onClick={() => !isRenewing && processRenewal(false)}
            >
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1" style={{ fontWeight: 600 }}>
                      One-Time Payment
                    </h6>
                    <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "0.9rem" }}
                    >
                      Pay once and renew manually when needed
                    </p>
                  </div>
                  <Badge
                    color="light"
                    style={{ background: "#e9f3f4", color: "#0D535D" }}
                  >
                    One-Time
                  </Badge>
                </div>
              </CardBody>
            </Card>
            <Card
              style={{
                cursor: isRenewing ? "not-allowed" : "pointer",
                border: "2px solid #e6e6e6",
                transition: "all 0.3s",
                opacity: isRenewing ? 0.6 : 1,
              }}
              onMouseEnter={(e) =>
                !isRenewing && (e.currentTarget.style.borderColor = "#0d535d")
              }
              onMouseLeave={(e) =>
                !isRenewing && (e.currentTarget.style.borderColor = "#e6e6e6")
              }
              onClick={() => !isRenewing && processRenewal(true)}
            >
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1" style={{ fontWeight: 600 }}>
                      Subscription (Auto-Renew)
                    </h6>
                    <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "0.9rem" }}
                    >
                      Automatic renewal every year for uninterrupted service
                    </p>
                  </div>
                  <Badge
                    color="light"
                    style={{ background: "#e9f3f4", color: "#0D535D" }}
                  >
                    Subscription
                  </Badge>
                </div>
              </CardBody>
            </Card>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowPaymentTypeModal(false)}
            disabled={isRenewing}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Card className="my-2">
        <h3
          className="card-header d-flex justify-content-between align-items-center"
          style={{ background: "#0D535D", color: "#fff" }}
        >
          Renew your plan
        </h3>
        <CardBody>
          <Row className="align-items-stretch g-3">
            <Col xs="12" md="4">
              <div style={{ height: 220, overflow: "hidden", borderRadius: 8 }}>
                <img
                  src={
                    "https://images.all-free-download.com/images/graphiclarge/beach_cloud_dawn_horizon_horizontal_landscape_ocean_601821.jpg"
                  }
                  alt="Plan visual"
                  className="img-fluid w-100 h-100"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </Col>
            <Col xs="12" md="8">
              <div
                style={{
                  border: "1px solid #e6e6e6",
                  borderRadius: 8,
                  padding: 16,
                  height: "100%",
                }}
              >
                <Row className="g-3 align-items-center">
                  <Col xs="12" lg="6">
                    <div
                      className="d-flex align-items-center mb-2"
                      style={{ gap: 8 }}
                    >
                      <h5 className="mb-0">
                        {subscriptionList?.farmType ?? "Per Farm"}
                      </h5>
                      <Badge
                        color="light"
                        style={{ background: "#e9f3f4", color: "#0D535D" }}
                      >
                        Yearly
                      </Badge>
                    </div>
                    <CardText className="text-muted">
                      Our most popular plan for Farm
                    </CardText>

                    <Row className="mt-3">
                      <Col xs="12" sm="6">
                        <ul
                          style={{
                            listStyle: "disc",
                            paddingLeft: 18,
                            marginBottom: 0,
                          }}
                        >
                          <li>
                            <span style={{ fontWeight: 600 }}>Farm Name</span>
                            <span> : {subscriptionList?.farmName ?? "-"}</span>
                          </li>
                          <li>
                            <span style={{ fontWeight: 600 }}>Farm Type</span>
                            <span>
                              {" "}
                              : {subscriptionList?.farmType ?? "Per Farm"}
                            </span>
                          </li>
                        </ul>
                      </Col>
                      <Col xs="12" sm="6" className="mt-2 mt-sm-0">
                        <ul
                          style={{
                            listStyle: "disc",
                            paddingLeft: 18,
                            marginBottom: 0,
                          }}
                        >
                          <li>
                            <span style={{ fontWeight: 600 }}>
                              Renewal Date
                            </span>
                            <span>
                              {" "}
                              : {subscriptionList?.renewalDate ?? "-"}
                            </span>
                          </li>
                          <li>
                            <span style={{ fontWeight: 600 }}>Amount</span>
                            <span>
                              {" "}
                              : {"$" + subscriptionList?.amount ?? "-"}
                            </span>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <div
                      className="mt-3 d-flex align-items-center"
                      style={{ gap: 8 }}
                    >
                      {subscriptionList?.paymentType === "Subscription" && (
                        <>
                          <Input
                            type="checkbox"
                            disabled={
                              subscriptionList?.paymentType !==
                                "Subscription" ||
                              isTogglingAutoRenew ||
                              !subscriptionList?.cancelSubscriptionDetailId
                            }
                            checked={isRenewalChecked}
                            onChange={(e) => {
                              const newCheckedState = e.target.checked;
                              setIsRenewalChecked(newCheckedState);
                              handleAutoRenewToggle(newCheckedState);
                            }}
                          />

                          <span
                            className={
                              subscriptionList?.paymentType !== "Subscription"
                                ? "text-muted"
                                : ""
                            }
                          >
                            Auto Renew
                            {isTogglingAutoRenew && (
                              <Spinner size="sm" className="ms-2" />
                            )}
                          </span>
                        </>
                      )}
                    </div>
                  </Col>
                  <Col xs="12" lg="6">
                    <div
                      className="h-100 d-flex justify-content-center gap-5 align-items-center p-5"
                      style={{ background: "#e9f3f4", borderRadius: 8 }}
                    >
                      <div
                        style={{
                          fontSize: 40,
                          fontWeight: 800,
                          color: "#0D1321",
                        }}
                      >
                        $199.00
                      </div>
                      <div className="w-100 h-75 d-flex flex-column gap-2">
                        <div className="d-grid gap-2">
                          <Button
                            color="success"
                            style={{
                              background: "#0d535d",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            className="w-75 d-flex justify-content-center align-items-center gap-2"
                            onClick={handleRenewNow}
                            disabled={
                              !subscriptionList?.showRenewSubscriptioBtn ||
                              isRenewing ||
                              isCancelling
                            }
                          >
                            {isRenewing ? (
                              <>Processing...</>
                            ) : (
                              <>
                                Renew Now
                                <FaExternalLinkAlt style={{ marginLeft: 6 }} />
                              </>
                            )}
                          </Button>
{(subscriptionList?.showCancelSubscriptionBtn) &&
                          <Button
                            color="secondary"
                            outline
                            className="w-75"
                            onClick={handleCancelSubscriptionClick}
                            disabled={
                              !subscriptionList?.showCancelSubscriptionBtn ||
                              isRenewing ||
                              isCancelling
                            }
                          >
                            {isCancelling ? (
                              <>Cancelling...</>
                            ) : (
                              "Cancel Subscription"
                            )}
                          </Button>
}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="my-2">
        <h3
          className="card-header d-flex justify-content-between align-items-center"
          style={{ background: "#0D535D", color: "#fff" }}
        >
          Renew History
        </h3>
        <CardBody>
          {/* <Row >
                        <Col md="9">
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Search</Label>
                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                            </FormGroup>
                        </Col>
                    </Row> */}
          <Row style={{ marginTop: "10px" }}>
            <Col>
              {subscriptionList == undefined && (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              )}
              {subscriptionList != undefined && subscriptionList != null && (
                <ProductTable products={subscriptionList} />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default ViewFarmSubscriptions;
